import React from 'react';

import { IconProps, PrepareIconProps } from './types';

export const prepareIcon = (iconProps: PrepareIconProps): React.ForwardRefExoticComponent<IconProps> =>
  React.forwardRef((props: IconProps, ref: React.Ref<HTMLImageElement>) => (
    <img {...props} {...iconProps} ref={ref} alt={iconProps.alt} />
  ));
